import { Counter, MyleCounterStyle } from "./Counters";
import { ICounters } from "./ICounters";

/**
 * Represents a set of communication's counters.
 * Implements the ICounters interface to track unread messages, tasks, and overdue items.
 */
class CommunicationsCounters implements ICounters {
    /** The number of unread messages. */
    private readonly unreadMessagesCount: number;

    /** The number of unread tasks. */
    private readonly unreadTasksCount: number;

    /** The number of unread external messages. */
    private readonly unreadExternalMessagesCount: number;

    /** The number of past due tasks. */
    private readonly pastDueTasksCount: number;

    /**
     * Creates an instance of CommunicationsCounters.
     * @param {number} unreadMessagesCount - The number of unread messages.
     * @param {number} unreadTasksCount - The number of unread tasks.
     * @param {number} unreadExternalMessagesCount - The number of unread external messages.
     * @param {number} pastDueTasksCount - The number of past due tasks.
     */
    constructor(
        unreadMessagesCount: number,
        unreadTasksCount: number,
        unreadExternalMessagesCount: number,
        pastDueTasksCount: number
    ) {
        this.unreadMessagesCount = unreadMessagesCount;
        this.unreadTasksCount = unreadTasksCount;
        this.unreadExternalMessagesCount = unreadExternalMessagesCount;
        this.pastDueTasksCount = pastDueTasksCount;
    }

    /**
     * Retrieves an array of Counter objects representing each type of communication's counter.
     * @returns {Counter[]} An array of counters with their respective value, label and style.
     */
    public getCounters(): Counter[] {
        return [
            new Counter(this.unreadMessagesCount, "Tooltip_UnreadMessagesLabel", MyleCounterStyle.blueCircleWithBackground),
            new Counter(this.unreadTasksCount, "Tooltip_UnreadTasksLabel", MyleCounterStyle.blueCircleWithBackground),
            new Counter(this.unreadExternalMessagesCount, "Tooltip_UnreadExternalCommunicationsLabel", MyleCounterStyle.blueCircleWithBackground),
            new Counter(this.pastDueTasksCount, "Tooltip_IncompleteTasksLabel", MyleCounterStyle.redCircleWithBackground)
        ];
    }

    /**
     * Determines if the counter can be displayed.
     * @returns {boolean} True if the counter can be displayed, otherwise false.
     */
    public showCounters(): boolean {
        return this.unreadMessagesCount !== 0
        || this.unreadTasksCount !== 0
        || this.unreadExternalMessagesCount !== 0
        || this.pastDueTasksCount !== 0;
    }
}

export { CommunicationsCounters };
